<!--个人信息设置-->
<template>
    <div class='container'>
        <div class="left">
            <div class="imgBox">
                <div class="imgs66">
                    <ResourceUpload :showFlodNames="['个人头像']" flodName="个人头像" ref="upload" ossRoute="companyImage"
                        v-model="picList" :fileLimit="1" :parentId="String(saveDatas.id)" listType='picture-card'>
                    </ResourceUpload>
                </div>
                <p class="p1" v-if="picList.length > 0" @click="handlerImgTailorClick">头像裁剪</p>
            </div>
            <div class="leftBox">
                <p class="p1">基本信息</p>
                <el-form :model="saveDatas" :rules="rules" ref="saveDatas" label-width="1.2rem" class="demo-ruleForm">
                    <div class="lineBox">
                        <div class="lineBoxleft">
                            <p class="p2"><span>*</span>绑定手机</p>
                            <p>{{ phone }}</p>
                        </div>
                        <div class="lineBoxright">
                            <p class="p3"><span>*</span>昵称</p>
                            <el-form-item prop="userName">
                                <el-input v-model="saveDatas.userName" size="small" style="width: 1.5rem;"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="lineBox">
                        <p class="p2"><span>*</span>邮箱</p>
                        <el-form-item prop="email">
                            <el-input v-model="saveDatas.email" placeholder="用于接收来自平台的邮件通知，非常重要" size="small"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="lineBox">
                    <div class="lineBoxleft">
                        <p class="p2">生日</p>
                        <el-date-picker value-format="yyyy-MM-dd" v-model="saveDatas.birthday" size="small"
                            style="width: 1.5rem;" type="date" placeholder="选择日期">
                        </el-date-picker>
                    </div>
                    <div class="lineBoxright">
                        <p class="p3">微信</p>
                        <el-input v-model="saveDatas.wechat" size="small" style="width: 1.5rem;"></el-input>
                    </div>
                </div>
                <div class="lineBox">
                    <div class="lineBoxleft">
                        <p class="p2">性别</p>
                        <el-select v-model="saveDatas.sex" style="width:1.3rem;margin-right: 0.05rem;" size="small"
                            placeholder="请选择">
                            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                        <img :src="require('@/assets/png/xinbie.png')" alt="">
                    </div>
                    <div class="lineBoxright">
                        <p class="p3">微博</p>
                        <el-input v-model="saveDatas.weibo" size="small" style="width: 1.5rem;"></el-input>
                    </div>
                </div>
                <div class="lineBox">
                    <div class="lineBoxleft">
                        <p class="p2">哪一年入行</p>
                        <el-date-picker value-format="yyyy" v-model="saveDatas.professionDate"
                            style="width: 1.2rem;margin-right: 0.1rem;" size="small" type="year" placeholder="选择年">
                        </el-date-picker>
                        <span class="p2" style="width: 0.6rem;">年 {{ getGzYear(saveDatas.professionDate) }} 年</span>
                    </div>
                    <div class="lineBoxright">
                        <span class="p3">职业</span>
                        <el-input v-model="saveDatas.career" size="small"
                            style="width: 1.4rem;margin-right: 0.1rem;"></el-input>
                    </div>
                </div>
                <div class="lineBox">
                    <div class="lineBoxleft">
                        <p class="p2">走遍世界的脚步</p>
                        <el-input v-model="saveDatas.countrySize" size="small"
                            style="width: 0.8rem;margin-right: 0.1rem;"></el-input>
                        <span class="p2">个国家</span>
                        <el-input v-model="saveDatas.citySize" size="small"
                            style="width: 0.8rem;margin-right: 0.1rem;"></el-input>
                        <span class="p2">个城市</span>
                    </div>
                </div>
                <div class="lineBox">
                    <div class="lineBoxleft">
                        <p class="p2">留给客户的话</p>
                    </div>
                </div>
                <div class="lineBox">
                    <el-input v-model="saveDatas.customerMessage" type="textarea" placeholder="请输入内容" rows="5"
                        show-word-limit>
                    </el-input>
                </div>
                <div class="lineBox">
                    <div class="lineBoxleft">
                        <p class="p2">我的相册</p>
                    </div>
                </div>
                <div class="lineBox" style="margin-bottom: 0.24rem;">
                    <div class="imgs66">
                        <ResourceUpload :showFlodNames="['我的相册']" flodName="我的相册" ref="upload1" ossRoute="userPicture"
                            v-model="picList1" :fileLimit="99" :parentId="String(saveDatas.id)" listType='picture-card'>
                        </ResourceUpload>
                    </div>
                </div>
                <div class="line"></div>
                <p class="p1">个人资料 <span>用于提现等资金需要，不会以任何形式向第三方透露</span></p>
                <div class="lineBox">
                    <div class="lineBoxleft" style="flex: 1;">
                        <p class="p2"><span>*</span>真实姓名</p>
                        <el-input style="width: 2rem;" size="small"></el-input>
                    </div>
                </div>
                <div class="lineBox">
                    <div class="lineBoxleft">
                        <p class="p2">身份证件类型</p>
                        <el-select v-model="value" style="width:2rem;margin-right: 0.1rem;" size="small" placeholder="请选择">
                            <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input style="width: 2rem;" placeholder="证件号码" size="small"></el-input>
                    </div>
                </div>
                <div class="lineBox">
                    <div class="lineBoxleft">
                        <p class="p2">收货地址</p>
                        <p @click="handlerSeeAddressClick" class="p4">查看</p>
                    </div>
                </div>
                <div class="lineBox">
                    <div class="lineBoxleft">
                        <p class="p2">银行信息</p>
                        <el-select v-model="value" style="width:2rem;margin-right: 0.1rem;" size="small" placeholder="请选择">
                            <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input style="width: 2rem;" placeholder="账号" size="small"></el-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="mainBoxRight">
            <div class="mainBoxRightTopBtn">
                <div @click="save('saveDatas')" class="btns" style="margin-right: 0.24rem">
                    保存
                </div>
                <div class="btns1">
                    返回
                </div>
            </div>
            <div class="mainBoxRightBox">
                <div class="mainBoxRightBoxTop">
                    <div class="topLeft">
                        <img v-if="picList.length > 0" class="imgs" :src="picList[0].url">
                        <img v-else class="imgs" src="#"></img>
                        <p class="p1">麦格仕国际旅行社（北京）有限公司</p>
                        <p class="p1">北京市朝阳区秀水街1号5号楼10层101号</p>
                    </div>
                    <div class="topRight">
                        <p class="p1">{{ saveDatas.userName }}</p>
                        <p class="p2">
                            经验 <span>{{ getGzYear(saveDatas.professionDate) }}</span> 年
                        </p>
                        <div class="btns1">
                            资深定制师
                        </div>
                        <div class="line"></div>
                        <div>
                            <p class="p3">
                                <img class="imgs" :src="require('@/assets/png/iponeY.png')">
                                <span>{{ phone }}</span>
                            </p>
                            <p class="p3">
                                <img class="imgs" :src="require('@/assets/png/wxY.png')">
                                <span>{{ saveDatas.wechat }}</span>
                            </p>
                            <p class="p3">
                                <img class="imgs" :src="require('@/assets/png/wbY.png')">
                                <span>{{ saveDatas.weibo }}</span>
                            </p>
                        </div>

                    </div>
                </div>
                <div class="footer">
                    <div class="describe">
                        <div class="describeLeft"></div>
                        <div class="describeText">{{ saveDatas.customerMessage }}</div>
                    </div>
                    <div class="footerImg">
                        <img v-for="(item, index) in picList1" :key="index" :src="item.url">

                    </div>
                    <p class="p1">My Footprints</p>
                    <p class="p1"> <span>{{ saveDatas.countrySize }}</span> 个国家， <span>{{ saveDatas.citySize }}</span> 个城市
                    </p>

                    <div class="info">
                        <div class="infoBox" v-for="item in infoDatas" :key="item.title">
                            <p class="p1">{{ item.num }}</p>
                            <p class="p2">{{ item.title }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <addressSeePopup ref="addressSeePopup"></addressSeePopup>
        <ImgTailor @imgUrlClick="imgUrlClick" :persionImg="picList[0].url" v-if="picList.length > 0" ref="ImgTailor">
        </ImgTailor>


    </div>
</template>

<script>
import addressSeePopup from './child/addressSeePopup.vue';
import ResourceUpload from "@/components/Upload/ResourceUpload.vue";

import Api from "@/components/Api/index.js"
import ImgTailor from '../../../../components/Img-Tailor.vue';
export default {
    components: {
        addressSeePopup,
        ResourceUpload,
        ImgTailor
    },
    data() {
        return {
            picList: [],
            picList1: [],
            imgUrl: '',//用来裁剪的图片
            rules: {
                userName: [
                    { required: true, message: '请输入昵称', trigger: 'blur' },
                    { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
                ],
                email: [
                    { required: true, message: '请输入邮箱', trigger: 'blur' },
                    { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                ]
            },
            saveDatas: {
                email: null,
                userName: null,
                birthday: '',
                sex: '男',
                professionDate: null,
                wechat: null,
                weibo: null,
                countrySize: null,
                citySize: null,
                customerMessage: null,
                career: '',
                imageUrl:'',
                id: null,

            },
            value: '',
            options: [{
                value: '1',
                label: '男'
            }, {
                value: '2',
                label: '女'
            }],
            options1: [{
                value: '1',
                label: '中国居民身份证'
            }, {
                value: '2',
                label: '港澳居民来往大陆通行证'
            },
            {
                value: '3',
                label: '台湾居民来往大陆通行证'
            }, {
                value: '4',
                label: '护照'
            }],
            phone: '',
            dialogImageUrl: '',
            dialogVisible1: false,
            infoDatas: [{
                num: 3,
                title: '经验/年',
                key: ''
            },
            {
                num: 0,
                title: '案例',
                key: ''
            },
            {
                num: 200000,
                title: '粉丝',
                key: ''
            },
            {
                num: 600000,
                title: '关注',
                key: ''
            },
            {
                num: 60000,
                title: '获赞',
                key: ''
            }]

        }
    },
    computed: {},
    watch: {
        picList: {
            handler(n, m) {
                if (n.length > 0) {
                    this.imgUrl = n[0].url
                }
            }
        },
    },
    methods: {
        //图片裁剪
        handlerImgTailorClick() {
            this.$refs.ImgTailor.visible = true
            this.$refs.ImgTailor.imgBase64(this.imgUrl)
        },
        //替换原来的照片
        imgUrlClick(url) {
            this.picList[0].url = url
        },
        updateUserInfo(obj) {
            new Api("user").updateUserInfo(obj).then((result) => {
                if (result.status == 200) {
                    this.$message({
                        message: "保存成功",
                        type: "success",
                    });
                    this.getUserInfo()
                }
            }).catch((err) => {
                this.$message({
                    type: "error",
                    message: '保存失败',
                });
            });
        },
        //保存
        save(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let obj = JSON.parse(JSON.stringify(this.saveDatas))
                    obj.professionDate = obj.professionDate + '-01-01'
                    console.log(obj, '看看保存的数据');
                    console.log(this.$refs.upload.fileList, '看看照片列表');
                    let arr = this.$refs.upload.fileList.filter(item => !item.id)
                    //说明头像更新 需要存入更新用户接口
                    if (arr.length > 0) {
                        this.$refs.upload.manualUpload(this.picList, obj.id).then(res => {
                            obj.imageUrl = res.url
                            this.$refs.upload1.manualUpload(this.picList1, obj.id)
                            this.updateUserInfo(obj)
                        })
                    }else {
                        this.updateUserInfo(obj)
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        mergeObjects(obj1, obj2) {
            for (let key in obj2) {
                if (obj1.hasOwnProperty(key)) {
                    obj1[key] = obj2[key];
                }
            }
            return obj1;
        },
        getUserInfo() {
            new Api("user").selectUserInfo().then((result) => {
                if (result.status == 200) {
                    console.log(result.data, '看看数据8888');
                    this.phone = result.data.loginAccount
                    this.saveDatas = this.mergeObjects(this.saveDatas, result.data)
                    console.log(this.saveDatas, '坎坎坷坷看看');
                }
            }).catch((err) => {
                this.$message({
                    type: "error",
                    message: '系统异常',
                });
            });
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible1 = true;
        },
        //查看地址
        handlerSeeAddressClick() {
            this.$refs.addressSeePopup.init()
        },
        //获取工作年‘
        getGzYear(val) {
            const year = new Date().getFullYear();
            let result
            if (!val) {
                return 0
            } else {
                let year1
                if (typeof val == 'string' && val.length > 4) {
                    year1 = Number(val.split('-')[0])
                    result = year - year1 > 0 ? year - year1 : 0
                }
                else {
                    result = year - val > 0 ? year - val : 0
                }
                return result
            }
        }
    },
    created() {

    },
    mounted() {
        this.getUserInfo()
    },
}
</script>
<style lang='scss' scoped>
/deep/ .el-upload--picture-card {
    height: 1rem;
    width: 1rem;
    line-height: 1.05rem;
}

/deep/ .el-upload-list--picture-card .el-upload-list__item {
    height: 1rem;
    width: 1rem;
}

/deep/ .el-form-item__label {
    // text-align: left !important;
}

/deep/ .el-form-item__content {
    margin-left: 0 !important;
}

/deep/ .el-form-item {
    margin-bottom: 0 !important;
    width: 79%;
}

.container {
    padding: 0.3rem 1.5rem;
    display: flex;
    justify-content: space-between;
    background-color: #fff;

    img {
        object-fit: cover;
    }

    .imgs66 {
        width: 1.1rem;
        height: 1.1rem;
        position: relative;
        margin-right: 0.1rem;
        // background-color: #FAFAFA;
        // border-radius: 50%;
        overflow: hidden;
    }

    .left {
        position: relative;
        padding-top: 0.7rem;

        .imgBox {
            display: flex;
            align-items: center;
            position: absolute;
            top: 0;
            // right: 0;
            // left: 37.5%;
            left: 50%;
            transform: translateX(-50%);

            .p1 {
                border-bottom: 1px solid rgb(187, 187, 187);
                cursor: pointer;
                color: rgb(16, 16, 16);
                font-size: 0.14rem;
            }
        }

        .leftBox {
            width: 6rem;
            min-height: 8rem;
            border-radius: 0.25rem;
            background-color: rgba(255, 255, 255, 1);
            color: rgba(16, 16, 16, 1);
            font-size: 0.14rem;
            border: 1px solid rgba(214, 214, 214, 1);
            padding: 0.24rem 0.27rem;

            .p1 {
                color: rgba(16, 16, 16, 1);
                font-size: 0.22rem;
                font-family: SourceHanSansSC-regular;
                margin-bottom: 0.1rem;

                span {
                    color: rgb(129, 124, 126);
                    font-size: 0.14rem;
                    margin-left: 0.1rem;
                }
            }

            .p2 {
                color: rgba(16, 16, 16, 0.72);
                font-size: 0.14rem;
                font-family: SourceHanSansSC-regular;
                width: 1.2rem;
                position: relative;

                span {
                    position: absolute;
                    left: -0.1rem;
                    top: 0;
                    color: red;
                }
            }

            .p3 {
                color: rgba(16, 16, 16, 0.72);
                font-size: 0.14rem;
                font-family: SourceHanSansSC-regular;
                width: 0.5rem;
                position: relative;

                span {
                    position: absolute;
                    left: -0.1rem;
                    top: 0;
                    color: red;
                }
            }

            .p4 {
                color: rgb(50, 189, 254);
                font-size: 0.16rem;
                cursor: pointer;
            }

            .lineBox {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 0.2rem;

                .lineBoxleft {
                    display: flex;
                    align-items: center;
                    flex: 1;
                }

                .lineBoxright {
                    display: flex;
                    align-items: center;
                }
            }

            .line {
                height: 1px;
                border-bottom: 1px solid #CFCFCF;
                margin-bottom: 0.24rem;
            }
        }
    }

    .mainBoxRight {
        min-height: 5rem;
        display: flex;
        flex-direction: column;
        align-items: center;

        .mainBoxRightTopBtn {
            display: flex;
            align-items: center;
            margin-bottom: 0.2rem;

            .btns {
                width: 1.1rem;
                height: 0.85rem;
                text-align: center;
                background-color: #FF6637;
                color: white;
                font-size: 0.18rem;
                line-height: 0.85rem;
                border-radius: 0.1rem;
                box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
                cursor: pointer;
            }

            .btns1 {
                width: 1.1rem;
                height: 0.85rem;
                text-align: center;
                background-color: #F0E6E2;
                color: #FF6637;
                font-size: 0.18rem;
                line-height: 0.85rem;
                border-radius: 0.1rem;
                cursor: pointer;
            }
        }

        .mainBoxRightBox {
            padding: 0.2rem 0.18rem;
            width: 3.8rem;
            min-height: 4rem;
            border-radius: 0.1rem;
            box-shadow: 0px 2px 6px 0px rgba(221, 88, 39, 18);

            .mainBoxRightBoxTop {
                display: flex;
                margin-bottom: 0.1rem;

                .topLeft {
                    flex: 1;
                    margin-right: 0.1rem;

                    .imgs {
                        height: 1.8rem;
                        width: 100%;
                    }

                    .p1 {
                        font-size: 0.12rem;
                        color: #858585;
                    }
                }

                .topRight {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    border-bottom: 1px solid #000;

                    .p1 {
                        font-size: 0.2rem;
                        color: #E55319;
                        margin-bottom: 0.24rem;
                    }

                    .p2 {
                        color: rgb(24, 9, 4);
                        font-size: 0.24rem;
                        margin-bottom: 0.14rem;

                        span {
                            font-size: 0.35rem;
                            font-weight: bolder;
                        }
                    }

                    .p3 {
                        display: flex;
                        align-items: center;
                        margin-bottom: 0.1rem;

                        .imgs {
                            width: 0.2rem;
                            height: 0.2rem;
                            margin-right: 0.06rem;
                        }

                        span {
                            font-size: 0.12rem;
                            color: #000;
                        }
                    }

                    .btns1 {
                        width: 1rem;
                        height: 0.3rem;
                        line-height: 0.3rem;
                        background: black;
                        font-size: 0.18rem;
                        color: white;
                        text-align: center;
                        margin-bottom: 0.2rem;
                    }

                    .line {
                        padding: 0 0.1rem;
                        width: 100%;
                        height: 1px;
                        border-bottom: 2px solid #000;
                        margin-bottom: 0.1rem;
                    }
                }
            }

            .footer {
                .describe {
                    display: flex;
                    align-items: center;
                    margin-bottom: 0.1rem;
                    padding-left: 0.2rem;

                    .describeLeft {
                        height: 1rem;
                        background: rgb(221, 88, 39);
                        width: 0.05rem;
                        margin-right: 0.1rem;
                    }

                    .describeText {
                        font-size: 0.12rem;
                        height: 1rem;
                    }
                }

                .footerImg {
                    margin-bottom: 0.24rem;
                    display: flex;
                    overflow-x: scroll;

                    img {
                        width: 1rem;
                        height: 1rem;
                        margin-right: 0.1rem;

                        &:nth-last-child(1) {
                            margin-right: 0;
                        }
                    }
                }

                .p1 {
                    font-family: "Microsoft Yahei";
                    font-size: 0.16rem;
                    text-align: center;
                    margin-bottom: 0.1rem;

                    span {
                        font-size: 0.2rem;
                        font-weight: bold;
                    }
                }

                .info {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .infoBox {
                        display: flex;
                        align-items: center;
                        flex-direction: column;

                        .p1 {
                            color: rgb(16, 16, 16);
                            font-size: 0.21rem;
                        }

                        .p2 {
                            color: rgba(0, 0, 0, 0.6);
                            font-size: 0.12rem;
                            margin-top: 0.05rem;
                        }
                    }
                }

            }











        }
    }
}
</style>